import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  liveMapMobileSurfaceAtom,
  LiveMapMobileSurfaceEnum,
  liveMapPollingUiAtom,
  useIsMobile,
} from "@ryde/shared";

import { LiveMapMapDisplayedSummary } from "./live-map.map-displayed-summary";
import { LiveMapMobileMapStatsPanelStyled } from "./live-map.mobile-map-stats-panel.styled";
import { LiveMapPollStatusPill } from "./live-map.poll-status-pill";
import { useLiveMapMapPollTooltip } from "./use-live-map-map-poll-tooltip";
import { useLiveMapToolbarStats } from "./use-live-map-toolbar-stats";

/** Mobile stats row (level 2): desktop-style "Rides on map" poll indicator on map view. */
export const LiveMapMobileMapStatsPanel: FC = () => {
  const { isMobile } = useIsMobile();
  const mobileSurface = useRecoilValue(liveMapMobileSurfaceAtom);
  const { mapRidesCount } = useLiveMapToolbarStats();
  const { mapPollingRideIds, isMapPollFetchInFlight, lastSynchroMapDate } =
    useRecoilValue(liveMapPollingUiAtom);
  const mapPollTooltip = useLiveMapMapPollTooltip();

  const isMapSurface = mobileSurface === LiveMapMobileSurfaceEnum.Map;
  const isMapPollingActive = Boolean(mapPollingRideIds?.length);

  if (!isMobile || !isMapSurface) {
    return null;
  }

  return (
    <LiveMapMobileMapStatsPanelStyled>
      <LiveMapPollStatusPill
        tooltip={mapPollTooltip}
        isInFlight={Boolean(isMapPollFetchInFlight)}
        isPollingActive={isMapPollingActive}
        hasSyncedAtLeastOnce={Boolean(lastSynchroMapDate)}
      >
        <LiveMapMapDisplayedSummary ridesCount={mapRidesCount} />
      </LiveMapPollStatusPill>
    </LiveMapMobileMapStatsPanelStyled>
  );
};
